<div class="verifycode full-width" style="padding: 1.5rem 0 1rem 0;" [ngClass]="{'hasErr': errorMessage !== ''}"
     *ngIf="(verificationType == 'password') || (exchangeId && verificationType != 'fido2') ">
    <!--    <p>{{'mfa_required.verify_'+verificationType | uppercase | translate}}</p>-->
    <app-input-group [options]="inputGroupOption" (btnEvent)="_submit($event)" (inputEvent)="_updatePassword($event)">
    </app-input-group>
</div>

<div class="" *ngIf="verificationType === 'password'" style="position: relative; width: 100%; display: contents;">
    <div class="mat-error custom" style="transform: translateY(-129px); display: inline-block;">{{errorMessage | translate}}</div>
    <a class="gl-forgot-pw" style="transform: translateY(-40px); text-align: right" [routerLink]="[]" (click)="forgotPassword()">{{'LOGIN.FORGOT_PASSWORD' | translate}} ?</a>
</div>

<div class="authapp full-width"
     *ngIf="(!exchangeId && (verificationType != 'password')) || verificationType == 'fido2'">
    <div class="wrapper" *ngIf="verificationType">
        <div class="icon">
            <div class="circle-ripple">
                <span class="{{'cidaas-icon-'+verificationType}}"></span>
            </div>
        </div>
        <div class="content">
            <h1 *ngIf="push_selected_number">{{push_selected_number}}</h1>
            <h3 *ngIf="verificationType_CamelCase">{{'LOGIN.AUTHENTICATION.'+verificationType_CamelCase+'.NOTIFICATIONTEXT' | translate}}</h3>
        </div>
    </div>
</div>
<div class="" *ngIf="verificationType !== 'password'" style="float: right">
    <div class="mat-error">{{errorMessage | translate}}</div>
</div>

<ng-container *cidPageLoader="pageLoading"></ng-container>
